import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { loyaltyClient } from '@integration/api-client/loyalty';

export const { actions, effects } = generateNgrxServiceClient(
  'Loyalty',
  loyaltyClient
);
